import { ArdoqId } from '@ardoq/api-types';
import { HIGHLIGHTED_ITEM_BACKGROUND_COLOR } from '../items/consts';
import {
  TimelinePhasesWithRenderingParameters,
  TimelineViewGraphHierarchy,
} from '../types';
import { getHighlightedItemIds } from './calculations';

type GetTimelinePhasesWithHoverBackgroundArgs = {
  hoveredItemId: string | null;
  focusedItemId: ArdoqId | null;
  filteredViewGraphHierarchy: TimelineViewGraphHierarchy;
  itemPhases: TimelinePhasesWithRenderingParameters[];
};
/**
 * Iterate over the clean phases (without any background color) and add the highlight background.
 */
export const getTimelinePhasesWithHighlightBackground = ({
  hoveredItemId,
  focusedItemId,
  filteredViewGraphHierarchy,
  itemPhases,
}: GetTimelinePhasesWithHoverBackgroundArgs) => {
  const hasNoHighlightedItems = !hoveredItemId && !focusedItemId;
  const highlightedItemIds = hasNoHighlightedItems
    ? new Set()
    : getHighlightedItemIds(
        hoveredItemId,
        focusedItemId,
        filteredViewGraphHierarchy
      );

  return highlightedItemIds.size
    ? itemPhases.map(phasesOfOneItem => {
        return highlightedItemIds.has(phasesOfOneItem.itemModel.id) &&
          !phasesOfOneItem.itemModel.isContext
          ? {
              ...phasesOfOneItem,
              backgroundColor: HIGHLIGHTED_ITEM_BACKGROUND_COLOR,
            }
          : phasesOfOneItem;
      })
    : itemPhases;
};
